import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CodeProjectsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CodeProjects",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M15.166 12.614a1.136 1.136 0 0 0-1.4.808l-2.455 9.164a1.142 1.142 0 1 0 2.207.592l2.456-9.164a1.14 1.14 0 0 0-.808-1.4M20.237 15.192a1.144 1.144 0 0 0-1.617 1.616l1.55 1.55-1.55 1.55a1.144 1.144 0 0 0 1.617 1.616l2.358-2.357a1.144 1.144 0 0 0 0-1.616zM8.809 15.047a1.15 1.15 0 0 0-1.618 0l-2.358 2.358a1.147 1.147 0 0 0 .001 1.617l2.358 2.358a1.14 1.14 0 0 0 1.617-.001 1.143 1.143 0 0 0-.001-1.616l-1.55-1.55 1.55-1.549a1.144 1.144 0 0 0 0-1.617"
    }), /*#__PURE__*/_jsx("path", {
      d: "M24 4.571H3.429A3.433 3.433 0 0 0 0 8v20.571A3.433 3.433 0 0 0 3.429 32H24a3.433 3.433 0 0 0 3.429-3.429V8A3.433 3.433 0 0 0 24 4.571m1.144 24c0 .631-.513 1.144-1.144 1.144H3.429c-.631 0-1.144-.513-1.144-1.144V8c0-.63.513-1.144 1.144-1.144H24c.63 0 1.144.513 1.144 1.144z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M24 0H10.286a1.143 1.143 0 0 0 0 2.285H24A5.72 5.72 0 0 1 29.715 8v13.714a1.143 1.143 0 0 0 2.285 0V8c0-4.411-3.589-8-8-8"
    })]
  }));
};
CodeProjectsIcon.displayName = 'CodeProjectsIcon';